import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { getToolTipIcon, HandleSkeletion } from "../../../utils/constants";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import { CustomizeSpan, PrimaryDiv, SecondaryShift } from "../style";

const CommonCard = ({
  viewData,
  loading = false,
  rowSize = false,
  viewMarginTop,
  iconVisible = true,
  key_colors = {},
}) => {
  return (
    <CommonGrid2
      container
      columnSpacing={2}
      rowSpacing={loading ? 0 : 2}
      marginTop={viewMarginTop}
    >
      {viewData?.map((item, index) => {
        return (
          <CommonGrid2
            item
            size={{
              xs: 12,
              md: rowSize ? 6 : 4,
              sm: 6,
            }}
            key={index}
          >
            {loading ? (
              <HandleSkeletion height={100} />
            ) : item.component === "split-part" ? (
              <CommonGrid2 container spacing={2}>
                {item.data.map((innerItem) => (
                  <CommonGrid2
                    size={6}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"8px"}
                  >
                    <PrimaryDiv>
                      <CommonGrid2
                        display={"flex"}
                        gap={"8px"}
                        alignItems="center"
                      >
                        <Tooltip arrow title={innerItem.title} placement="top">
                          <Typography
                            variant="p"
                            color="#344054"
                            fontSize="15px"
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                          >
                            {innerItem.title}
                          </Typography>
                        </Tooltip>

                        {iconVisible &&
                          // <Fragment>
                          (key_colors?.[
                            innerItem?.titleName || innerItem?.toggleName
                          ] === "inferred"
                            ? getToolTipIcon("Inferred")
                            : key_colors?.[
                                innerItem?.titleName || innerItem?.toggleName
                              ] === "extracted"
                            ? ""
                            : key_colors?.[
                                innerItem?.titleName || innerItem?.toggleName
                              ] === "user_added"
                            ? getToolTipIcon("User Added")
                            : "")}
                      </CommonGrid2>
                      <Typography
                        variant="h4"
                        fontWeight={600}
                        fontSize={"15px"}
                        display="flex"
                        alignItems="center"
                        gap="10px"
                        style={{ wordBreak: "break-word" }}
                      >
                        {innerItem.name}
                      </Typography>
                    </PrimaryDiv>
                  </CommonGrid2>
                ))}
              </CommonGrid2>
            ) : (
              <PrimaryDiv>
                <Typography
                  variant="p"
                  color="#475467"
                  fontSize="15px"
                  display={"flex"}
                  gap={"10px"}
                  alignItems={"center"}
                >
                  {item.title}
                  {item.anomaly_content}
                  {item.iconVisible && item.content
                    ? ""
                    : key_colors?.[item?.titleName || item?.toggleName] ===
                      "inferred"
                    ? getToolTipIcon("Inferred")
                    : key_colors?.[item?.titleName || item?.toggleName] ===
                      "extracted"
                    ? ""
                    : key_colors?.[item?.titleName || item?.toggleName] ===
                      "user_added"
                    ? getToolTipIcon("User Added")
                    : ""}
                </Typography>
                {item.name && (
                  <Typography
                    variant="h4"
                    fontWeight={600}
                    fontSize={"15px"}
                    display="flex"
                    alignItems="center"
                    gap="10px"
                    style={{ wordBreak: "break-word" }}
                  >
                    {item.image && <img src={item.image} />}
                    {item.name}
                  </Typography>
                )}
                {item.shift && (
                  <SecondaryShift>
                    {item.shift.map((item, index) => (
                      <StatusChange key={index}>
                        <DotColor
                          color={
                            item === "Morning" || item === "Day"
                              ? "green"
                              : "#101828"
                          }
                        ></DotColor>
                        {item}
                      </StatusChange>
                    ))}
                  </SecondaryShift>
                )}
                {item.additional && (
                  <SecondaryShift>
                    {item.additional.map((subItem, index) => {
                      return subItem && subItem?.image ? (
                        <StatusChange key={index}>
                          <img src={subItem.image} width={20} />
                          {subItem.name}
                        </StatusChange>
                      ) : (
                        <StatusChange key={index}>{subItem.name}</StatusChange>
                      );
                    })}
                  </SecondaryShift>
                )}
                {item.multi_additional && (
                  <SecondaryShift>
                    {item.multi_additional.map((subItem, index) => {
                      return (
                        <StatusChange
                          key={index}
                          // border={
                          //   subItem.name === "inferred"
                          //     ? "1px solid #D1EFFF"// rgb(0, 112, 242)"
                          //     : subItem.name === "user_added"
                          //     ? "1px solid rgb(7, 148, 85)"
                          //     : "1px solid rgb(30, 31, 33)"
                          // }
                          border={"none"}
                          boxShadow={"none"}
                          color={
                            subItem.name === "inferred"
                              ? "#223548" //rgb(0, 112, 242)"
                              : subItem.name === "user_added"
                              ? "#223548" //"rgb(7, 148, 85)"
                              : "#223548" //"rgb(30, 31, 33)"
                          }
                          background={
                            subItem.name === "inferred"
                              ? "#D1EFFF" //"rgb(235, 248, 255)"
                              : subItem.name === "user_added"
                              ? "#DAFDF5" //"rgb(219, 250, 230)"
                              : "rgba(0, 0, 0, 0.08)"
                          }
                        >
                          {subItem.content}{" "}
                          {subItem.name === "inferred" ? (
                            <CustomizeSpan display="flex">
                              {getToolTipIcon("Inferred", true)}
                            </CustomizeSpan>
                          ) : subItem.name === "user_added" ? (
                            <CustomizeSpan display="flex">
                              {getToolTipIcon("User Added", true)}
                            </CustomizeSpan>
                          ) : (
                            <CustomizeSpan display="flex">
                              {getToolTipIcon("Extracted", true)}
                            </CustomizeSpan>
                          )}
                        </StatusChange>
                      );
                    })}
                  </SecondaryShift>
                )}
              </PrimaryDiv>
            )}
          </CommonGrid2>
        );
      })}
    </CommonGrid2>
  );
};
export default CommonCard;
